module.exports = "<select class=\"form-control\" [(ngModel)]=\"model\" (change)=\"selectOnChange()\" [required]=\"required\" (blur)=\"selectOnBlur($event)\">\r\n  <option [selected]=\"\"></option>\r\n  <option \r\n    *ngFor=\"let item of list\" \r\n    [value]=\"item?.id\"\r\n    [selected]=\"item?.id == model\">{{item?.name}}</option>\r\n</select>\r\n<div class=\"invalid-feedback\" *ngIf=\"errorMessage\">{{ errorMessage }}</div>"


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/dropdown/dropdown-base.component.html
// module id = ../../../../../src/app/components/dropdown/dropdown-base.component.html
// module chunks = main